import React from 'react';
export const CustomPhoneNumberField = ({
  label,
  fieldname,
  country_code,
  area_code,
  number,
  ...props
}: any) => {
  const phoneNumber = `+${country_code || ''}(${area_code})-${number}`;
  return (
    <>
      <label className="inputLabel">{label}</label>
      <div className="inputFieldDiv">
        <input className="cardDetailsInput" value={phoneNumber} {...props} />
        <div className="overlaySection" />
      </div>
    </>
  );
};
